import { plainToClass } from "class-transformer";
import { SiteLevelSummaryDto } from "./sites.objects";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../shared/scripts/table-column-visibility";
import { Unique } from "../../../shared/scripts/array-functions";
import { IFilter } from "../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../shared/scripts/filtering/filtering.utilities";

export class SitesPage implements IFilter {

    sites: SiteLevelSummaryDto[];
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;
    filterDropdownIds: string[];
    visibleUserEmails: string;

    token: string;

    constructor(allSitesJson: any) {
        $(() => {
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');

            this.sites = plainToClass(SiteLevelSummaryDto, <SiteLevelSummaryDto[]>allSitesJson);

            this.sites = this.sites.map((site: SiteLevelSummaryDto) => {
                site.initialize();
                return site;
            });

            this.filterDropdownIds = ['#study-dropdown', '#site-manager-dropdown'];
            this.initializeFilters();

            this.initializeTable();

            this.initializeModal();

        });
    }

    initializeFilters(): void {

        let studyValues: string[] = [];
        this.sites.forEach((site: SiteLevelSummaryDto) => { studyValues.push(...site.StudyList); });
        InitializeFilterDropdown('#study-dropdown', Unique(studyValues, true, ["None Selected"]), this);

        let values: string[] = [];
        this.sites.forEach((site: SiteLevelSummaryDto) => { values.push(...site.UserNames); });
        values.push("Unassigned");
        InitializeFilterDropdown('#site-manager-dropdown', Unique(values, true, ["None Selected"]), this);
    }


    initializeTable(): void {
        this.dataTable = $('#sites-table').DataTable({
            //"dom": '<"top-controls"<"search-bar"f>>rtip',
            "dom": 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            //fixedColumns: {
            //    leftColumns: 3
            //},
            order: [[0, 'asc']],
            columns: [
                // {
                //     data: null,
                //     title: '<input type="checkbox" />',
                //     className: "ctms-table-col-check",
                //     orderable: false,
                //     render: function () {
                //         return '<input type="checkbox" />';
                //     }
                // },
                { data: { _: "SiteNumber", sort: "SiteNumber" }, title: "Site Number" },
                { data: { _: "SiteName", sort: "SiteName" }, title: "Site Name" },
                //{
                //    data: null,
                //    title: "Site Manager",
                //    render: function (data, type, row) {
                //        if (row.CTMSUserSites && row.CTMSUserSites.length > 0) {
                //            const userSite = row.CTMSUserSites.find(us => us.CTMSUser && us.CTMSUser.Name);
                //            if (userSite && userSite.CTMSUser) {
                //                return userSite.CTMSUser.Name;
                //            }
                //        }
                //        return "";
                //    }
                //},
                //{
                //    data: null,
                //    title: "Studies",
                //    render: function (data, type, row) {
                //        if (row.CTMSSiteStudies && row.CTMSSiteStudies.length > 0) {
                //            return row.CTMSSiteStudies
                //                .map(ss => ss.CTMSStudy && ss.CTMSStudy.Name ? ss.CTMSStudy.Name : "")
                //                .filter(name => name)
                //                .join(", ");
                //        }
                //        return "";
                //    }
                //},
                {
                    data: "UserNames",
                    title: "Site Manager",
                    render: function (data) {
                        return Array.isArray(data) ? data.join(", ") : "";
                    }
                },
                {
                    data: null,
                    title: "Studies",
                    render: function (data, type, row) {
                        if (row.CTMSStudy && row.CTMSStudy.length > 0) {
                            return row.CTMSStudy
                                .map(ss => ss.Name ? ss.Name : "")
                                .filter(name => name)
                                .sort()
                                .join(", ");
                        }
                        return "";
                    }
                },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<a href="/secure/ctms/site-details?id=${row.Id}" title="Edit"><i class="ctms-icon-pencil"></i></a>`;
                    }
                }

            ],
            data: this.sites,
        //    createdRow: function (row, data, dataIndex) {
        //        $(row).removeClass('odd even');
        //        if (dataIndex % 2 === 0) {
        //            $(row).addClass('even');
        //        } else {
        //            $(row).addClass('odd');
        //        }
        //    }
        });

        //$('.dataTables_filter').appendTo('#datatable-search-container');
        $('#custom-dt-search').on('input', function () {
            $('#sites-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('.ctms-icon-button[title="Clear Search"]').on('click', function () {
            $('#custom-dt-search').val('');
            $('#sites-table').DataTable().search('').draw();
        });

    }

    updateTable(matchingSites: SiteLevelSummaryDto[]): void {

        this.dataTable.clear();
        this.dataTable.rows.add(matchingSites).draw();
    }

    triggerFilter(): void {

        let matchingSites: SiteLevelSummaryDto[] = [];

        let siteMatches: boolean;
        this.sites.forEach((site: SiteLevelSummaryDto) => {

            siteMatches = true;

            if (!site.matchesFilter(this.getSelectedDropdownValues('#study-dropdown'), this.getSelectedDropdownValues('#site-manager-dropdown'))) {
                siteMatches = false;
            }

            if (siteMatches) { matchingSites.push(site); }
        });

        this.updateTable(matchingSites);
    }

    getSelectedDropdownValues(selectId: string): any {
        //return $(selectId).selectpicker('val');
        return $(selectId).val();
    }

    resetFilters(): void {

        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#custom-dt-search').val('');

        this.dataTable.search('').draw();
        this.updateTable(this.sites);
    }

    initializeModal() {
        $('#newSiteDialog').modal({
            backdrop: 'static',
            show: false,
        });

        // bind buttons
        $('#addSiteButton').on('click', () => {
            this.openAddModal();
        });

        $('#newSiteDialog .ctms-button-save').on('click', (e) => {
            const f = document.getElementById('siteDialogForm') as HTMLFormElement;

            if (f.checkValidity()) {
                $('#siteDialogForm').removeClass('ctms-invalid-form');

                $.ajax({
                    url: `/secure/ctms/sites/sites?handler=AddSite`,
                    headers: { "RequestVerificationToken": this.token },
                    type: 'POST',
                    data: $('#newSiteDialog .ctms-field-submit').serialize(),
                    success: (resp) => {
                        // console.log(resp);

                        const newSite = plainToClass(SiteLevelSummaryDto, <SiteLevelSummaryDto>resp);
                        newSite.initialize();

                        this.sites.push(newSite);
                        this.resetFilters();

                        $('#newSiteDialog').modal('hide');
                    }
                });
            } else {
                $('#siteDialogForm').addClass('ctms-invalid-form');
            }

            e.preventDefault();
            e.stopPropagation();
        });

    }

    async openAddModal() {
        // reset form
        $('#newSiteDialog .ctms-field-submit').each((i, e) => {
            if (e.getAttribute('type') === 'text') {
                $(e).val('');
            }
            if (e.getAttribute('type') === 'checkbox') {
                $(e).prop('checked', false);
            }
        });

        // open modal
        $('#newSiteDialog').modal('show');

    }
}